<template>
  <div class="myTable">
    <!-- 搜索栏 -->
    <div class="searchNav">
      <div class="search-form">
        <div class="search-items">
          <div class="search-item">
            <span class="label">版本名称：</span>
            <el-input v-model="searchInfo.versionName" clearable placeholder="请输入版本名称" @keyup.enter.native="search"></el-input>
          </div>
          <div class="search-item">
            <span class="label">平台：</span>
            <el-select v-model="searchInfo.platform" clearable @change="search" placeholder="请选择">
              <el-option label="Android" :value="0"></el-option>
              <el-option label="iOS" :value="1"></el-option>
            </el-select>
          </div>
          <div class="search-item">
            <span class="label">状态：</span>
            <el-select v-model="searchInfo.status" clearable @change="search" placeholder="请选择">
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="search-btn">
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="success" icon="el-icon-plus" @click="openAdd">新增版本</el-button>
      </div>
    </div>

    <!-- 表格 -->
    <div class="tableStyle">
      <el-table v-loading="loading" :data="tableData" style="width: 100%;" max-height="620px" border>
        <el-table-column type="index" width="50" label="#"></el-table-column>
        <el-table-column prop="versionName" label="版本名称" width="110"></el-table-column>
        <el-table-column prop="versionCode" label="版本号" width="90"></el-table-column>
        <el-table-column prop="platform" label="平台" width="90">
          <template slot-scope="scope">
            <el-tag :type="scope.row.platform === 0 ? 'success' : 'primary'" size="small">
              {{ scope.row.platform === 0 ? 'Android' : 'iOS' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="apkSize" label="文件大小" width="110">
          <template slot-scope="scope">
            {{ formatSize(scope.row.apkSize) }}
          </template>
        </el-table-column>
        <el-table-column prop="isForceUpdate" label="强制更新" width="90">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isForceUpdate === 1 ? 'danger' : 'info'" size="small">
              {{ scope.row.isForceUpdate === 1 ? '是' : '否' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="应用市场" min-width="380">
          <template slot-scope="scope">
            <div class="market-status-grid">
              <div v-for="item in marketList" :key="item.key" class="market-status-item">
                <span class="market-name">{{ item.label }}</span>
                <el-select
                  v-model="scope.row[item.field]"
                  size="mini"
                  class="market-select"
                  @change="changeMarket(scope.row, item.key, $event)">
                  <el-option
                    v-for="opt in marketStatusOptions"
                    :key="opt.value"
                    :label="opt.label"
                    :value="opt.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="updateDesc" label="更新说明" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="status" label="状态" width="90">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              @change="confirmChangeStatus(scope.row, $event)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160">
          <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="130">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" style="color: #F56C6C;" @click="confirmDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
        <template slot="empty">
          <el-empty :image-size="160"></el-empty>
        </template>
      </el-table>
      <el-pagination
        style="text-align: right; margin-top: 10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="searchInfo.pageNumber"
        :page-size="searchInfo.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="sizes, prev, pager, next, total"
        :total="total">
      </el-pagination>
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" @close="resetForm">
      <el-form :model="formData" :rules="formRules" ref="versionForm" label-width="100px">
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="版本名称" prop="versionName">
              <el-input v-model="formData.versionName" placeholder="如 2.0.0"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="版本号" prop="versionCode">
              <el-input-number v-model="formData.versionCode" :min="1" style="width:100%;" placeholder="如 200"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="平台" prop="platform">
          <el-radio-group v-model="formData.platform">
            <el-radio :label="0">Android</el-radio>
            <el-radio :label="1">iOS</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="安装包">
          <div class="upload-apk-wrap">
            <!-- 未上传 / 重新上传入口 -->
            <el-upload
              action="#"
              :http-request="uploadApk"
              :before-upload="beforeApkUpload"
              :show-file-list="false"
              :disabled="uploading">
              <el-button size="small" :loading="uploading" icon="el-icon-upload2">
                {{ uploading ? '上传中...' : (formData.downloadUrl ? '重新上传' : '上传安装包') }}
              </el-button>
            </el-upload>
            <!-- 已上传文件信息 -->
            <div v-if="formData.downloadUrl" class="uploaded-info">
              <i class="el-icon-document" style="color:#409EFF;"></i>
              <span class="file-name" :title="uploadedFileName">{{ uploadedFileName }}</span>
              <span class="file-size">{{ formatSize(formData.apkSize) }}</span>
              <el-button type="text" size="mini" style="color:#F56C6C;" @click="clearUpload">
                <i class="el-icon-close"></i>
              </el-button>
            </div>
            <div class="upload-tip">支持 .apk / .ipa 文件，上传后自动填充下载地址和文件大小</div>
          </div>
        </el-form-item>
        <el-form-item label="下载地址">
          <el-input v-model="formData.downloadUrl" placeholder="上传安装包后自动填充，也可手动输入"></el-input>
        </el-form-item>
        <el-form-item label="更新说明">
          <el-input type="textarea" v-model="formData.updateDesc" rows="3" placeholder="请输入版本更新说明"></el-input>
        </el-form-item>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="强制更新">
              <el-radio-group v-model="formData.isForceUpdate">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-radio-group v-model="formData.status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="应用市场">
          <div class="market-form-grid">
            <div v-for="item in marketList" :key="item.key" class="market-form-item">
              <span class="market-form-label">{{ item.label }}</span>
              <el-select v-model="formData[item.field]" size="small" style="width:100px;">
                <el-option
                  v-for="opt in marketStatusOptions"
                  :key="opt.value"
                  :label="opt.label"
                  :value="opt.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="submitForm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { axios } from '../../config/axios';

  const defaultForm = () => ({
    versionName: '',
    versionCode: undefined,
    platform: 0,
    apkSize: undefined,
    downloadUrl: '',
    isForceUpdate: 0,
    updateDesc: '',
    isXiaomi: 0,
    isHuawei: 0,
    isVivo: 0,
    isOppo: 0,
    isHonor: 0,
    isTencent: 0,
    status: 1,
  });

  export default {
    name: 'app-stat',
    data() {
      return {
        marketList: [
          { key: 'xiaomi',   label: '小米',   field: 'isXiaomi' },
          { key: 'huawei',   label: '华为',   field: 'isHuawei' },
          { key: 'vivo',     label: 'vivo',   field: 'isVivo' },
          { key: 'oppo',     label: 'OPPO',   field: 'isOppo' },
          { key: 'honor',    label: '荣耀',   field: 'isHonor' },
          { key: 'tencent',  label: '应用宝', field: 'isTencent' },
        ],
        marketStatusOptions: [
          { label: '未上架',   value: 0 },
          { label: '审核中',   value: 1 },
          { label: '审核通过', value: 2 },
          { label: '审核拒绝', value: 3 },
          { label: '跳过',     value: 4 },
          { label: '其他',     value: 5 },
        ],
        loading: false,
        submitting: false,
        tableData: [],
        total: 0,
        searchInfo: {
          versionName: '',
          platform: '',
          status: '',
          pageNumber: 1,
          pageSize: 10,
        },
        dialogVisible: false,
        dialogTitle: '新增版本',
        editId: null,
        formData: defaultForm(),
        uploading: false,
        uploadedFileName: '',
        formRules: {
          versionName: [{ required: true, message: '请输入版本名称', trigger: 'blur' }],
          versionCode: [{ required: true, message: '请输入版本号', trigger: 'blur' }],
          platform: [{ required: true, message: '请选择平台', trigger: 'change' }],
        },
      };
    },
    created() {
      this.pageInfo();
    },
    methods: {
      search() {
        this.searchInfo.pageNumber = 1;
        this.pageInfo();
      },
      pageInfo() {
        if (this.loading) return;
        this.loading = true;
        const params = { ...this.searchInfo };
        if (params.status === '') delete params.status;
        if (params.platform === '') delete params.platform;
        if (params.versionName === '') delete params.versionName;
        axios.get('/appVersion/list', { params }).then(res => {
          this.loading = false;
          if (res.code !== 200) {
            this.$message.error(res.message || '查询失败');
            return;
          }
          this.tableData = res.data.list || [];
          this.total = res.data.total || 0;
        }).catch(err => {
          console.log(err);
          this.loading = false;
        });
      },
      handleCurrentChange(val) {
        this.searchInfo.pageNumber = val;
        this.pageInfo();
      },
      handleSizeChange(val) {
        this.searchInfo.pageNumber = 1;
        this.searchInfo.pageSize = val;
        this.pageInfo();
      },
      openAdd() {
        this.editId = null;
        this.formData = defaultForm();
        this.dialogTitle = '新增版本';
        this.dialogVisible = true;
      },
      openEdit(row) {
        this.editId = row.id;
        this.uploadedFileName = row.downloadUrl ? row.downloadUrl.split('/').pop() : '';
        this.formData = {
          versionName: row.versionName,
          versionCode: row.versionCode,
          platform: row.platform,
          apkSize: row.apkSize,
          downloadUrl: row.downloadUrl,
          isForceUpdate: row.isForceUpdate,
          updateDesc: row.updateDesc,
          isXiaomi: row.isXiaomi,
          isHuawei: row.isHuawei,
          isVivo: row.isVivo,
          isOppo: row.isOppo,
          isHonor: row.isHonor,
          isTencent: row.isTencent,
          status: row.status,
        };
        this.dialogTitle = '编辑版本';
        this.dialogVisible = true;
      },
      resetForm() {
        this.$refs.versionForm && this.$refs.versionForm.resetFields();
        this.formData = defaultForm();
        this.editId = null;
        this.uploading = false;
        this.uploadedFileName = '';
      },
      beforeApkUpload(file) {
        const isApk = file.name.endsWith('.apk') || file.name.endsWith('.ipa');
        if (!isApk) {
          this.$message.error('只支持上传 .apk 或 .ipa 文件');
          return false;
        }
        return true;
      },
      uploadApk({ file }) {
        this.uploading = true;
        const formData = new FormData();
        formData.append('file', file);
        axios.post('/appVersion/upload', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          transformRequest: [(data) => data],
        }).then(res => {
          this.uploading = false;
          if (res.code !== 200) {
            this.$message.error(res.message || '上传失败');
            return;
          }
          const url = typeof res.data === 'string' ? res.data : (res.data && (res.data.url || res.data.downloadUrl || res.data.filePath || ''));
          this.formData.downloadUrl = url;
          this.formData.apkSize = file.size;
          this.uploadedFileName = file.name;
          this.$message.success('上传成功');
        }).catch(err => {
          console.log(err);
          this.uploading = false;
          this.$message.error('上传失败');
        });
      },
      clearUpload() {
        this.formData.downloadUrl = '';
        this.formData.apkSize = undefined;
        this.uploadedFileName = '';
      },
      submitForm() {
        this.$refs.versionForm.validate(valid => {
          if (!valid) return;
          this.submitting = true;
          const jsonConfig = {
            headers: { 'Content-Type': 'application/json' },
            transformRequest: [(data) => JSON.stringify(data)],
          };
          const req = this.editId
            ? axios.put(`/appVersion/${this.editId}`, this.formData, jsonConfig)
            : axios.post('/appVersion', this.formData, jsonConfig);
          req.then(res => {
            this.submitting = false;
            if (res.code !== 200) {
              this.$message.error(res.message || '操作失败');
              return;
            }
            this.$message.success(this.editId ? '修改成功' : '新增成功');
            this.dialogVisible = false;
            this.pageInfo();
          }).catch(err => {
            console.log(err);
            this.submitting = false;
            this.$message.error('操作失败');
          });
        });
      },
      confirmDelete(row) {
        this.$confirm(`确定要删除版本 ${row.versionName}（${row.platform === 0 ? 'Android' : 'iOS'}）吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          axios.delete(`/appVersion/${row.id}`).then(res => {
            if (res.code !== 200) {
              this.$message.error(res.message || '删除失败');
              return;
            }
            this.$message.success('删除成功');
            this.pageInfo();
          }).catch(err => {
            console.log(err);
            this.$message.error('删除失败');
          });
        }).catch(() => {});
      },
      confirmChangeStatus(row, newStatus) {
        const text = newStatus === 1 ? '启用' : '禁用';
        this.$confirm(`确定要${text}版本 ${row.versionName} 吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          axios.put(`/appVersion/${row.id}/status`, null, { params: { status: newStatus } }).then(res => {
            if (res.code !== 200) {
              this.$message.error(res.message || '操作失败');
              row.status = newStatus === 1 ? 0 : 1;
              return;
            }
            this.$message.success(`${text}成功`);
          }).catch(err => {
            console.log(err);
            row.status = newStatus === 1 ? 0 : 1;
            this.$message.error('操作失败');
          });
        }).catch(() => {
          row.status = newStatus === 1 ? 0 : 1;
        });
      },
      changeMarket(row, market, newStatus) {
        axios.put(`/appVersion/${row.id}/market`, null, { params: { market, status: newStatus } }).then(res => {
          if (res.code !== 200) {
            this.$message.error(res.message || '操作失败');
            this.pageInfo();
            return;
          }
          this.$message.success('更新成功');
        }).catch(err => {
          console.log(err);
          this.pageInfo();
          this.$message.error('操作失败');
        });
      },
      formatSize(bytes) {
        if (!bytes) return '--';
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / 1024 / 1024).toFixed(1) + ' MB';
      },
      formatTime(time) {
        if (!time) return '--';
        return time.replace('T', ' ').substring(0, 19);
      },
    },
  };
</script>

<style lang="less" scoped>
  .searchNav {
    padding: 16px 16px 0 16px;
    background: #fff;
    border-radius: 4px;
    display: flex;
    align-items: flex-start;
    margin-bottom: 12px;

    .search-form {
      flex: 1;
      padding-right: 16px;

      .search-items {
        display: flex;
        flex-wrap: wrap;

        .search-item {
          display: flex;
          align-items: center;
          margin-bottom: 12px;
          margin-right: 16px;

          .label {
            white-space: nowrap;
            color: #606266;
            font-size: 12px;
          }

          .el-input {
            width: 180px !important;
            /deep/ .el-input__inner {
              height: 32px;
              line-height: 32px;
            }
          }

          .el-select {
            width: 150px !important;
            /deep/ .el-input__inner {
              height: 32px;
              line-height: 32px;
            }
          }
        }
      }
    }

    .search-btn {
      padding-bottom: 12px;
      white-space: nowrap;
      .el-button {
        height: 32px;
        line-height: 32px;
        padding: 0 16px;
      }
    }
  }

  .tableStyle {
    background: #fff;
    padding: 12px 16px 16px;
    border-radius: 4px;
  }

  .market-status-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 6px 8px;
  }

  .market-status-item {
    display: flex;
    align-items: center;
    gap: 4px;

    .market-name {
      font-size: 12px;
      color: #606266;
      white-space: nowrap;
      min-width: 34px;
    }

    .market-select {
      width: 88px !important;
      /deep/ .el-input__inner {
        height: 26px;
        line-height: 26px;
        padding: 0 6px;
        font-size: 12px;
      }
      /deep/ .el-input__icon {
        line-height: 26px;
      }
    }
  }

  .market-form-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px 12px;
  }

  .market-form-item {
    display: flex;
    align-items: center;
    gap: 6px;

    .market-form-label {
      font-size: 13px;
      color: #606266;
      white-space: nowrap;
      min-width: 34px;
    }
  }

  .upload-apk-wrap {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .uploaded-info {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 6px 10px;
      background: #f0f7ff;
      border: 1px solid #c6e2ff;
      border-radius: 4px;
      max-width: 100%;

      .file-name {
        flex: 1;
        font-size: 13px;
        color: #303133;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 260px;
      }

      .file-size {
        font-size: 12px;
        color: #909399;
        white-space: nowrap;
      }
    }

    .upload-tip {
      font-size: 12px;
      color: #909399;
    }
  }
</style>
